import React, { useState } from "react";
import {
  sendClientSideSplitTrackEvent,
  useClientSideSplitTreatments,
} from "@leafly-com/split-next";
import getConfig from "next/config";

import useBrowserStorage from "hooks/useBrowserStorage";
import { getSplitKey } from "utils/split/getSplitKey";

import ChatIcon from "../Icons/chat.svg";
import X from "../Icons/x.svg";

const { publicRuntimeConfig } = getConfig();

const BuddeeChat = () => {
  const [chatSeenAt, setChatSeenAt] = useBrowserStorage<Date | null>(
    "local",
    "buddee_chat_seen_at",
    null
  );
  // show chat if it hasn't been seen in the last 24 hours as we don't want to annoy users yet we want to make sure they know about it
  const [isChatVisible, setChatVisible] = useState(
    !chatSeenAt ||
      new Date().getTime() - new Date(chatSeenAt).getTime() >
        1000 * 60 * 60 * 24
  );
  const setChatSeen = () => {
    setChatSeenAt(new Date());
    setChatVisible(false);
  };

  const splitKey = getSplitKey();

  const { treatments, isLoading } = useClientSideSplitTreatments(
    "webWeb_buddeeChat_frontend",
    splitKey
  );
  const chatEnabled =
    !isLoading && treatments.webWeb_buddeeChat_frontend.treatment === "on";

  const openChat = () => {
    setChatVisible(false);
    sendClientSideSplitTrackEvent(
      "webWeb_buddeeChatClicked_frontend",
      splitKey
    );
    window.open(
      publicRuntimeConfig.buddeeChatUrl,
      "buddeechat",
      "width=500,height=700,popup=true"
    );
  };

  return chatEnabled ? (
    <div className="relative h-90">
      <div
        className="w-12 h-12 bg-blue-500 rounded-full absolute bottom-0 flex items-center justify-center"
        onClick={() => openChat()}
        onKeyDown={(event) => {
          if (event.key === "F11") {
            openChat();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Open Chat"
      >
        <ChatIcon className="w-16 h-16" data-testid="chatIcon" />
      </div>

      {isChatVisible && (
        <div className="absolute w-52 bg-white elevation-low rounded bottom-16 left-0 p-2 text-xs">
          <button
            onClick={setChatSeen}
            className="text-lg border-none bg-transparent cursor-pointer float-right"
            aria-label="Close"
            data-testid="closeButton"
          >
            <X className="w-6 h-6 ml-1" />
          </button>
          <p>
            Introducing the new Leafly Leafbot! Let me know if I can help you
            find what you're looking for.
          </p>
        </div>
      )}
    </div>
  ) : null;
};

export default BuddeeChat;
